import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-item',
  template: `
    <div [formGroup]="formGroup">
      <nz-form-item>
        <nz-form-label [nzFor]="controlName" [nzRequired]="isRequired">{{ label }}</nz-form-label>
        <nz-form-control>
          <input *ngIf="disabled != null" nz-input [attr.disabled]="disabled" [formControlName]="controlName" maxlength="{{ maxLength }}" />
          <input *ngIf="disabled == null" nz-input [formControlName]="controlName" maxlength="{{ maxLength }}" />
        </nz-form-control>
        <app-control-messages [control]="formGroup.controls[controlName]"></app-control-messages>
      </nz-form-item>
    </div>
  `,
})
export class FormItemComponent {
  @Input() label: string;

  @Input() formGroup: FormGroup;

  @Input() controlName: string;

  @Input() isRequired = true;

  @Input() maxLength = 255;

  @Input() disabled = null;

  constructor() {}
}
